var styleDataHash = '2fddfb69';  
export const injectCss = (() => {
  var css = `.glob_fontElementMap,.vUNzW{font-family:var(--ricos-font-family,unset)}.vNPZG{color:var(--ricos-custom-link-color,var(--ricos-action-color,#116dff));font-family:var(--ricos-custom-link-font-family,unset);font-size:var(--ricos-custom-link-font-size,unset);font-style:var(--ricos-custom-link-font-style,unset);font-weight:var(--ricos-custom-link-font-weight,unset);letter-spacing:var(--ricos-custom-link-letter-spacing,unset);line-height:var(--ricos-custom-link-line-height,unset);min-height:var(--ricos-custom-link-min-height,unset);text-decoration:var(--ricos-custom-link-text-decoration,none)}@supports not (contain:inline-size){@media only screen and (max-width:640px){.vNPZG{font-size:var(--ricos-custom-link-font-size,unset)}}}@container (width < 640px){.vNPZG{font-size:var(--ricos-custom-link-font-size,unset)}}[dir] ._8n0qz:hover{cursor:text}[dir] .a37RS:hover{cursor:pointer}.OZ2iW{display:flex}[dir=ltr] .OZ2iW{margin-right:5px}[dir=rtl] .OZ2iW{margin-left:5px}.BMEYm{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));max-width:270px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.BMEYm:hover{text-decoration:underline}[dir] .sqLo3:hover{cursor:pointer}@supports not (contain:inline-size){@media only screen and (max-width:640px){.BMEYm{max-width:160px}}}@container (width < 640px){.BMEYm{max-width:160px}}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





